module.exports = __webpack_public_path__ + "img/Slide24.1319db45.png";